// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { appendClaimQuery, hasClaimAccess, type AccessCredentials } from '@/services/claimHttp';

export type GameDefinitionsRequest = {
  url: string;
  headers: Record<string, string>;
};

/**
 * How the hole screen reads the game catalogue, or null when it cannot.
 *
 * The catalogue is what turns a round's game ids into hazard buttons: a game is a hazard when its
 * name says so (hazardTypeFromName), and the names come from here. A signed-in player reads it
 * with their bearer token. A claim guest has no token, but the gateway opens
 * /api/game-definitions to ?claimToken= and ?inviteToken= (deploy/envoy/envoy.yaml) and the
 * scorecard already reads it that way; until 2026-10-07 the hole screen did not, so a guest
 * playing a round with Water or Bunker selected never saw the buttons the host saw.
 */
export const gameDefinitionsRequest = (
  apiBaseUrl: string | null | undefined,
  token: string | null | undefined,
  claimSession: AccessCredentials | null | undefined,
): GameDefinitionsRequest | null => {
  if (!apiBaseUrl) {
    return null;
  }
  const url = `${apiBaseUrl}/api/game-definitions`;
  if (token) {
    return { url, headers: { Authorization: `Bearer ${token}` } };
  }
  if (claimSession && (hasClaimAccess(claimSession) || !!claimSession.inviteToken?.trim())) {
    return { url: appendClaimQuery(url, claimSession), headers: {} };
  }
  return null;
};
